"use client";

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useContext, useMemo } from "react";
import { mergeSearchLabels, DEFAULT_SEARCH_LABELS, type SearchLabels } from "./searchLabelHelpers";
const SearchLabelsContext = createContext<SearchLabels>(DEFAULT_SEARCH_LABELS);
export function SearchLabelsProvider(t0) {
  const $ = _c(5);
  const {
    labels,
    children
  } = t0;
  let t1;
  if ($[0] !== labels) {
    t1 = mergeSearchLabels(labels);
    $[0] = labels;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const merged = t1;
  let t2;
  if ($[2] !== children || $[3] !== merged) {
    t2 = <SearchLabelsContext.Provider value={merged}>{children}</SearchLabelsContext.Provider>;
    $[2] = children;
    $[3] = merged;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}

/**
 * Localized search UI labels. Falls back to English defaults when no
 * provider is mounted or the Contentful entry is missing fields.
 */
export function useSearchLabels() {
  return useContext(SearchLabelsContext);
}